import { render, staticRenderFns } from "./SetWorkgroup.vue?vue&type=template&id=4397a761"
import script from "./SetWorkgroup.vue?vue&type=script&lang=js"
export * from "./SetWorkgroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports